<template>
	<ul v-bind:id="params.name">
		<h3 class="label_radio">{{getLabel(params.label)}}  <span v-if="params.compulsory" class="star">*</span>:</h3>
		<div class="template_input pools pools_radio">
			<li v-for="(_value, key) in params.options" v-bind:class="answer === _value.value ? 'selected' : ''" v-on:click="active_pool" class="pool">
				<input type="radio" v-bind:id="params.name+'_'+key" v-bind:value="_value.value" v-bind:name="params.name" v-model="answer">
				<label v-bind:for="params.name+'_'+key" v-on:touchstart="forceFocus" v-on:touchend="forceFocus" class="poolLabel">{{getLabel(_value.label)}}</label>
			</li>
		</div>
	</ul>
</template>
<script>

import componentTools from '@/libs/componentTools.js';
import lib from '@/libs/main.js';

export default {
	name: 'pools_radio_input',
	data() {
		return {
			answer : false,
		}
	},
	props : ['params', 'oldValue', 'lang', 'answer2'],
	computed : {
	},
	methods : {
		validate : function(v) {
			return typeof(v) == 'string' && v.length;
		},
		notifyUpdate : function(val) {
			this.$emit('validateField', this.params.name, val);
		},
		getLabel : componentTools.getLabel,
		forceFocus : function(event){
			let label = event.target;
			if(!label || !label.htmlFor) return;
			let input = document.getElementById(label.htmlFor);
			if(!input || !input.click) return;
			input.click();
		},
		active_pool: function(event){
			this.answer = event.target.getElementsByTagName("input")[0].value;
		}
	},
	watch: {
		answer : function(val){
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		},
		oldValue : function(val){
			if(!val) this.answer = false;
		},
		answer2 : function(val){
			if(val=="-1") this.answer = false;
			else this.answer = val;
			if(this.validate(val)) this.notifyUpdate(val);
			else this.notifyUpdate();
		}
	},
	mounted : function(){

		if(this.oldValue && this.oldValue.length) this.answer = this.oldValue;
	}
};
</script>

<style lang="less">
@import '../../assets/less/conf.import.less';

.pools {
	display: flex;
	flex-direction: row;
	justify-content: center;
	flex-wrap: wrap;
	li {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 106px;
		user-select : none;
		height: 56px;
		vertical-align: middle;
		margin-top: @margin;
		margin-left: @margin;
		margin-right: @margin;
		border-radius: 5px;
		border: 1px solid @cGrey_Light_3;
		cursor: pointer;
		z-index: 1;
	}
	input[type="radio"] {
		display: none !important;
	}
	.poolLabel{
		width: 100%;
		max-width: 100% !important;
		margin-top: 10px !important;
		display: inline-block;
		text-align: center !important;
		position: relative !important;
		word-break: break-word;
		margin : @margin auto;
		font-size: 12px !important;
		z-index: 2;
		pointer-events: none;
	}
}
</style>




// WEBPACK FOOTER //
// src/components/candidate_forms/pools_radio_input.vue